import {Query, QueryFilters, matchQuery} from "@tanstack/react-query";
import {queryClient} from ".";
import {noop} from "lodash-es";

let pendingInvalidations: (QueryFilters | undefined)[] = [];
export function directlyInvalidateQuery(filters: QueryFilters | undefined): void {
  const cache = queryClient.getQueryCache();
  cache.findAll(filters).forEach(query => {
    query.invalidate();
  });
  pendingInvalidations.push(filters);
}

function refetchInvalid(): Promise<void> {
  const cache = queryClient.getQueryCache();
  const promises = cache
    .getAll()
    .filter(
      query =>
        !query.isDisabled() &&
        pendingInvalidations.some(invalidation => !invalidation || matchQuery(invalidation, query)),
    )
    .map(query => refetchAfterInFlight(query));
  pendingInvalidations = [];

  return Promise.all(promises).then(noop);
}

// An in-flight fetch may have read the server before the write that invalidated it.
async function refetchAfterInFlight(query: Query): Promise<void> {
  if (query.state.fetchStatus === "fetching") {
    await query.fetch().catch(noop);
  }
  const refetch = query.fetch().catch(noop);
  if (query.state.fetchStatus !== "paused") {
    await refetch;
  }
}

let bulkUpdateCount = 0;

export async function performBulkUpdate<R>(f: () => Promise<R>): Promise<R> {
  try {
    bulkUpdateCount += 1;
    return await f();
  } finally {
    bulkUpdateCount -= 1;
    if (bulkUpdateCount === 0) {
      await refetchInvalid();
    }
  }
}

export async function deferInvalidation(f: () => Promise<any>): Promise<void> {
  await f();
  if (bulkUpdateCount == 0) {
    await refetchInvalid();
  }
}
